export const Footer = () => {
	return (
		<footer id="footer" className="footer">
			<div className="content has-text-centered">
				<p>
					Powered using <a href="https://bulma.io">Bulma</a> and <a href="https://reactjs.org">React</a>.
					<br />
					Copyright © 2021-2022 Asada Hinata. All Rights Reserved.
				</p>
			</div>
		</footer>
	);
};

export default Footer;
